export default "__VITE_ASSET__207c244c__"